import { render, staticRenderFns } from "./ProductsCountWidget.vue?vue&type=template&id=4deef31e&"
import script from "./ProductsCountWidget.vue?vue&type=script&lang=js&"
export * from "./ProductsCountWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports